import {
  LegType,
  OptionType,
  TradeReference,
} from '@oai-frontend-monorepo/types';
import SymbolParser from '../symbol/SymbolParser';
import { strategyIsCredit } from './strategyIsCredit';

interface Params {
  symbol?: string;
  tradeRef?: TradeReference;
}

const parseLegTypeFromTradeRef = ({
  symbol,
  tradeRef,
}: Params): LegType | undefined => {
  if (!symbol) {
    return undefined;
  }

  const callStrikes = tradeRef?.symbols
    ?.filter((s) => new SymbolParser(s).type === OptionType.CALL)
    .map((s) => new SymbolParser(s).strike!);

  const symbolType = new SymbolParser(symbol).type;
  const symbolStrike = new SymbolParser(symbol).strike;

  if (symbolType === OptionType.CALL && callStrikes?.length) {
    const lowerCallStrike = Math.min(...callStrikes);

    if (strategyIsCredit(tradeRef?.strategy)) {
      return symbolStrike === lowerCallStrike
        ? LegType.SHORT_CALL
        : LegType.LONG_CALL;
    }

    return symbolStrike === lowerCallStrike
      ? LegType.LONG_CALL
      : LegType.SHORT_CALL;
  }

  const putStrikes = tradeRef?.symbols
    ?.filter((s) => new SymbolParser(s).type === OptionType.PUT)
    .map((s) => new SymbolParser(s).strike!);

  if (symbolType === OptionType.PUT && putStrikes?.length) {
    const upperPut = Math.max(...putStrikes);

    if (strategyIsCredit(tradeRef?.strategy)) {
      return symbolStrike === upperPut ? LegType.SHORT_PUT : LegType.LONG_PUT;
    }

    return symbolStrike === upperPut ? LegType.LONG_PUT : LegType.SHORT_PUT;
  }

  return undefined;
};

export default parseLegTypeFromTradeRef;
